import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// biome-ignore lint/style/useImportType: required for JSX runtime compatibility with older toolchains
import React from 'react';
import { toast, Slide } from 'react-toastify';
export const DEFAULT_NOTIFICATION_TIMEOUT_IN_MS = 5_000;
export const NOTIFICATION_TIMEOUT_INFINITE = 999_999;
const baseOptions = {
    position: 'top-right',
    hideProgressBar: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'colored',
    transition: Slide,
};
const ToastMessage = (props) => {
    const { title, message } = props;
    return (_jsx("div", { className: 'notification', children: _jsxs("div", { className: 'notification-message', role: 'alert', children: [title && _jsx("h4", { className: 'title', children: title }), _jsx("div", { className: 'message', children: message })] }) }));
};
const normalizeArgs = (optionsOrTitle, timeout, callback, priority) => {
    // Handle the new options object format
    if (optionsOrTitle && typeof optionsOrTitle === 'object' && !React.isValidElement(optionsOrTitle)) {
        return { ...optionsOrTitle };
    }
    // Handle legacy format with multiple arguments
    return {
        title: typeof optionsOrTitle === 'string' ? optionsOrTitle : undefined,
        timeout,
        callback,
        priority,
    };
};
const mapOptions = (options) => {
    const { timeout, callback, priority, // does not work like that with react-toastify, so we ignore it
    iconClassName, closeButton = false, hideProgressBar = true, closeOnClick = true, } = options;
    return {
        ...baseOptions,
        autoClose: timeout || DEFAULT_NOTIFICATION_TIMEOUT_IN_MS,
        onClick: callback,
        hideProgressBar,
        closeOnClick,
        // replace the default built-in icons
        icon: _jsx("span", { className: `rioglyph ${iconClassName}` }),
        // in case a close button is requested, ignore the auto-injected "closeToast" prop
        // as otherwise it will be passed onto the underlying DOM element
        closeButton: closeButton
            ? ({ closeToast: ignoreCloseToast }) => (_jsx("button", { className: 'notification-close', type: 'button', children: _jsx("span", { className: 'rioglyph rioglyph-remove' }) }))
            : false,
    };
};
const Notification = (() => {
    const notify = (type, message, optionsOrTitle, timeout, callback, priority) => {
        // Normalize arguments
        const { title, timeout: time, callback: cb, priority: prio, closeButton, closeOnClick, hideProgressBar, } = normalizeArgs(optionsOrTitle, timeout, callback, priority);
        // Map icon class names based on type
        const iconClassNames = {
            default: '',
            success: 'rioglyph-ok text-size-18',
            info: 'rioglyph-info-sign text-size-20',
            warn: 'rioglyph-exclamation-sign text-size-20',
            error: 'rioglyph-error-sign text-size-20',
        };
        if (type === 'default') {
            return toast(_jsx(ToastMessage, { message: message, title: title }), mapOptions({
                timeout: time,
                callback: cb,
                priority: prio,
                closeButton,
                closeOnClick,
                hideProgressBar,
                iconClassName: iconClassNames[type],
            }));
        }
        // Call the appropriate toast function
        return toast[type](_jsx(ToastMessage, { message: message, title: title }), mapOptions({
            timeout: time,
            callback: cb,
            priority: prio,
            closeButton,
            closeOnClick,
            hideProgressBar,
            iconClassName: iconClassNames[type],
        }));
    };
    // Wrappers for specific types
    const defaultNotification = (message, optionsOrTitle, timeout, callback, priority) => notify('default', message, optionsOrTitle, timeout, callback, priority);
    const info = (message, optionsOrTitle, timeout, callback, priority) => notify('info', message, optionsOrTitle, timeout, callback, priority);
    const success = (message, optionsOrTitle, timeout, callback, priority) => notify('success', message, optionsOrTitle, timeout, callback, priority);
    const warning = (message, optionsOrTitle, timeout, callback, priority) => notify('warn', message, optionsOrTitle, timeout, callback, priority);
    const error = (message, optionsOrTitle, timeout, callback, priority) => notify('error', message, optionsOrTitle, timeout, callback, priority);
    return {
        default: defaultNotification,
        success,
        info,
        warning,
        error,
    };
})();
export default Notification;
